import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Phone, MessageCircle, Mail, X, Headphones } from 'lucide-react';

const FloatingContact = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const contactOptions = [
    {
      icon: Mail,
      label: "E-Mail senden",
      to: "/contact",
      color: "bg-blue-600 hover:bg-blue-700"
    },
    {
      icon: MessageCircle,
      label: "Nachricht",
      to: "/contact",
      color: "bg-green-600 hover:bg-green-700"
    }
  ];

  return (
    <div className="fixed bottom-4 right-4 z-50 sm:bottom-6 sm:right-6">
      {/* Expanded Menu */}
      {isExpanded && (
        <div className="mb-4 space-y-3">
          <Card className="p-2 shadow-lg animate-slide-up max-w-xs">
            <CardContent className="p-2">
              <p className="text-sm font-medium text-gray-900 mb-3">
                Kontaktieren Sie uns
              </p>
              <div className="space-y-2">
                {contactOptions.map((option, index) => (
                  option.to ? (
                    <Button
                      key={index}
                      asChild
                      size="sm"
                      className={`w-full justify-start ${option.color} text-white`}
                    >
                      <Link to={option.to}>
                        <option.icon className="mr-2 h-4 w-4" />
                        {option.label}
                      </Link>
                    </Button>
                  ) : (
                    <Button
                      key={index}
                      asChild
                      size="sm"
                      className={`w-full justify-start ${option.color} text-white`}
                    >
                      <a href={option.href} target="_blank" rel="noopener noreferrer">
                        <option.icon className="mr-2 h-4 w-4" />
                        {option.label}
                      </a>
                    </Button>
                  )
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Main Contact Button */}
      <Button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`
          h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110
          ${isExpanded 
            ? 'bg-red-600 hover:bg-red-700 rotate-45' 
            : 'bg-blue-600 hover:bg-blue-700'
          }
        `}
      >
        {isExpanded ? (
          <X className="h-6 w-6 text-white" />
        ) : (
          <Headphones className="h-6 w-6 text-white" />
        )}
      </Button>
    </div>
  );
};

export default FloatingContact;